/* Native Shopify forms remain functional with JavaScript disabled. */
(() => {
  if (window.lrsCommerceReady) return;
  window.lrsCommerceReady = true;
  const members = (context, selector) => [
    ...(context.matches && context.matches(selector) ? [context] : []),
    ...context.querySelectorAll(selector)
  ];
  const init = (context = document) => {
    members(context, '.commerce-sort').forEach((form) => {
      if (form.dataset.commerceReady) return;
      form.dataset.commerceReady = 'true';
      form.addEventListener('submit', () => {
        // Keep filters, repeated values and tracking parameters while resetting pagination.
        form.querySelectorAll('[data-commerce-preserved]').forEach((field) => field.remove());
        new URL(window.location.href).searchParams.forEach((value, name) => {
          if (name === 'sort_by' || name === 'page') return;
          const field = document.createElement('input');
          field.type = 'hidden';
          field.name = name;
          field.value = value;
          field.dataset.commercePreserved = '';
          form.append(field);
        });
      });
    });
    members(context, '[data-commerce-product]').forEach((root) => {
      if (root.dataset.commerceReady) return;
      root.dataset.commerceReady = 'true';
      const selector = root.querySelector('[data-commerce-variant]');
      if (!selector) return;
      selector.addEventListener('change', () => {
        const option = selector.selectedOptions[0];
        if (!option) return;
        const available = option.dataset.available === 'true';
        const price = root.querySelector('[data-commerce-price]');
        const compare = root.querySelector('[data-commerce-compare]');
        const add = root.querySelector('[data-commerce-add]');
        const stock = root.querySelector('[data-commerce-stock]');
        if (price) price.textContent = option.dataset.price;
        if (compare) {
          compare.textContent = option.dataset.compare || '';
          compare.hidden = !option.dataset.compare;
        }
        if (add) { add.disabled = !available; add.textContent = available ? t('Add to bag') : t('Sold out'); }
        if (stock) stock.textContent = available ? t('Available to order') : t('Currently sold out');
        const quantity = root.querySelector('[name="quantity"]');
        if (quantity) {
          quantity.min = option.dataset.min || '1';
          quantity.step = option.dataset.step || '1';
          if (option.dataset.max) quantity.max = option.dataset.max;
          else quantity.removeAttribute('max');
          quantity.value = quantity.min;
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', selector.value);
        window.history.replaceState({}, '', url.toString());
        if (option.dataset.media) {
          const media = Array.from(root.querySelectorAll('[data-media-id]')).find((el) => el.dataset.mediaId === option.dataset.media);
          if (media) {
            const container = media.parentElement;
            const focused = document.activeElement;
            container.prepend(media);
            if (focused && document.contains(focused)) focused.focus({preventScroll: true});
          }
        }
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
